import { LegalPage } from "../components/LegalPage";
import { SEO } from "../lib/seo";

export const TermsPage = () => (
  <>
    <SEO
      title="Terms of Service"
      description="The terms that govern your use of Humaniti."
      path="/terms"
    />
    <LegalPage
      title="Terms of Service"
      effectiveDate="2026-04-23"
      intro={
        <p>
          By using Humaniti, you agree to these Terms. They cover account eligibility, acceptable
          conduct, payments, intellectual property, and dispute resolution.
        </p>
      }
      sections={[
        {
          id: "account",
          title: "1. Account",
          body: (
            <p>
              You must be 18+. You are responsible for keeping your account credentials secure. We
              may suspend accounts that violate these Terms or our Acceptable Use Policy.
            </p>
          ),
        },
        {
          id: "eligibility",
          title: "2. Eligibility",
          body: (
            <p>
              Annotators must complete identity verification (KYC) appropriate to their tier.
              Requesters must complete the workspace application and admin approval.
            </p>
          ),
        },
        {
          id: "payments",
          title: "3. Payments",
          body: (
            <p>
              Requesters pay per verified label. Annotators are paid per verified label after
              consensus. Disputes follow the appeal process described in our docs.
            </p>
          ),
        },
        {
          id: "ip",
          title: "4. Intellectual Property",
          body: (
            <p>
              Datasets produced through Humaniti are owned by the requester who funded the labeling.
              Network metadata (signatures, audit records) is owned by Humaniti.
            </p>
          ),
        },
        {
          id: "termination",
          title: "5. Termination",
          body: (
            <p>
              You may close your account at any time. We may close your account for material breach
              of these Terms or our Acceptable Use Policy.
            </p>
          ),
        },
        {
          id: "law",
          title: "6. Governing law",
          body: <p>To be specified in legal review.</p>,
        },
      ]}
    />
  </>
);
